import { styled, ListItemIcon } from "@mui/material";

export const ListItemIconStyled = styled(ListItemIcon)`
  padding-left: 8px;
`;
